module.exports = __webpack_public_path__ + "static/15-efc8e61fc91b0c5f58678b0f4da12631.jpg";